// Phase 15.1 — frontend analytics instrumentation (design §16.1).
//
// Fire-and-forget wrapper around POST /api/analytics/event. Never throws,
// never blocks the UI, and silently no-ops when the user isn't logged in
// (the endpoint requires auth). Reuses the AdBanner session id so events
// and ad impressions can be joined per session.

import { axiosInstance } from './axiosConfig';

const SESSION_KEY = 'sumbitrbuddy_session_id';

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'unknown';
  }
}

/**
 * Record a product analytics event. Safe to call from anywhere:
 * failures are swallowed and unauthenticated calls are skipped.
 *
 *   trackEvent('resume_uploaded', { source: 'resumes_manager' });
 */
export function trackEvent(event: string, properties?: Record<string, unknown>): void {
  try {
    if (!localStorage.getItem('token')) return; // endpoint requires auth
    void axiosInstance
      .post('/analytics/event', { event, properties, sessionId: getSessionId() })
      .catch(() => { /* analytics must never surface errors */ });
  } catch {
    /* ignore */
  }
}
